module.exports = __webpack_public_path__ + "img/betterave_a_salade.38be053c.jpeg";